import EnterFullscreenSvg from "../icons/enterFullscreen.svg";
import ExitFullscreenSvg from "../icons/exitFullscreen.svg";
import { useControls, usePlayerState } from "../providers/CoreProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";

export const FullscreenButton = ({ interactive }: { interactive: boolean }) => {
  const controls = useControls();
  const { isFullscreen } = usePlayerState();

  const toggleFullscreen = (e: React.MouseEvent) => {
    e.stopPropagation();
    controls?.toggleFullscreen?.();
  };

  const translations = useTranslations();

  return (
    <PlayerControlButtonComponent
      aria-label={translations(
        isFullscreen
          ? "player__a11y__voice_over_exit_fullscreen_button"
          : "player__a11y__voice_over_enter_fullscreen_button"
      )}
      aria-keyshortcuts="f"
      onClick={toggleFullscreen}
      interactive={interactive}
      Icon={isFullscreen ? <ExitFullscreenSvg /> : <EnterFullscreenSvg />}
      hoverText={translations(
        isFullscreen
          ? "player__a11y__hover_label_exit_fullscreen_button"
          : "player__a11y__hover_label_enter_fullscreen_button"
      )}
    />
  );
};

export default FullscreenButton;
